import React from 'react'

const StiTestingNeeded = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding5rem1 right-padding5rem1 py-md-5 py-4'>
            <div className=''>
                <div className=''>
                    <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                        When Is STD / STI Testing Needed?
                    </div>
                    <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                </div>

                <div className='py-2'>
                    <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                        STI testing service in Chicago is recommended in some situations when STI testing is necessary:
                    </div>
                </div>

                <div className='py-2'>
                    <div className='fs-ss-22 text-ss-secondary fw-700 text-montserrat'>
                        1) New Sexual Partner
                    </div>
                </div>

                <div className='pb-3'>
                    <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    When initiating a sexual relationship with a new partner, both partners should get tested for STIs before engaging in sexual activity.
                    </div>
                </div>

                <div className='py-2'>
                    <div className='fs-ss-22 text-ss-secondary fw-700 text-montserrat'>
                      2) Multiple Partners
                    </div>
                </div>

                <div className='pb-3'>
                    <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    If you have multiple sexual partners or engage in unprotected sex, regular STI testing is essential to monitor your sexual health and detect infections early.
                    </div>
                </div>

                <div className='py-2'>
                    <div className='fs-ss-22 text-ss-secondary fw-700 text-montserrat'>
                        3) Symptoms or Concerns
                    </div>
                </div>

                <div className='pb-3'>
                    <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    If you experience any symptoms of an STI or have concerns about your sexual health, it is crucial to seek testing to determine the causes and receive appropriate treatment if necessary.
                    </div>
                </div>

                <div className='py-2'>
                    <div className='fs-ss-22 text-ss-secondary fw-700 text-montserrat'>
                    4) Previous STI Diagnosis 
                    </div>
                </div>

                <div className='pb-3'>
                    <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    If you have been diagnosed with an STI, follow-up testing is necessary to ensure the infection has been successfully treated and prevent reinfection or complications.
                    </div>
                </div>

                <div className='py-2'>
                    <div className='fs-ss-22 text-ss-secondary fw-700 text-montserrat'>
                    5) Pregnancy Planning
                    </div>
                </div>

                <div className='pb-3'>
                    <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    STI testing is recommended before planning a pregnancy or during early prenatal care to protect the health of both the mother and the unborn child.
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default StiTestingNeeded